/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gatewayLog', [])
    .factory('gatewayLogService', GatewayLogService)
    .name;

/*@ngInject*/
function GatewayLogService($http, $q) {
    return {
        getGatewayLog: getGatewayLog
    };

    function getGatewayLog(startTs, endTs, limit, page, mac, devEui, msgTypes) {
        var deferred = $q.defer();
        var url = `/api/gatewayLog/?startTs=${startTs}&limit=${limit}&page=${page}`;

        if (endTs) {
            url += `&endTs=${endTs}`;
        }
        if (mac) {
            url += `&mac=${mac}`;
        }
        if (devEui) {
            url += `&devEui=${devEui}`;
        }
        if (msgTypes && msgTypes.length) {
            url += `&msgTypes=${msgTypes.join(',')}`;
        }

        $http.get(url).then(function success(responce) {
            deferred.resolve(responce.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/gateway-log.service.js